// extracted by mini-css-extract-plugin
module.exports = {"chatbot-widget__fab":"ChatbotWidget_chatbot-widget__fab__3e9Cn"};